var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTimerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 8492,
    transform: "translate(-560 -5447)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 604,
    transform: "translate(-560 -337)",
    fill: "url(#paint0_linear_2_4)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.5,
    y: -13,
    width: 58,
    height: 58,
    rx: 12,
    fill: "#7F56D9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2544 2H18.7573M16.0058 18.2V12.8M5 16.85C5.33687 14.2256 6.64353 11.8137 8.67217 10.0718C10.7008 8.32998 13.3103 7.37926 16.0058 7.4C17.7861 7.40186 19.5393 7.82747 21.1151 8.64033C22.691 9.45319 24.0423 10.629 25.0533 12.067C26.0642 13.5049 26.7046 15.1621 26.9195 16.8963C27.1344 18.6305 26.9174 20.3899 26.2871 22.0237C25.6568 23.6575 24.632 25.1169 23.3007 26.2767C21.9693 27.4365 20.3711 28.262 18.6432 28.6825C16.9153 29.103 15.1092 29.1059 13.3799 28.6909C11.6506 28.2759 10.0497 27.4555 8.71447 26.3L5 23.06",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8787 22H4V28.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_4",
    x: -25.5,
    y: -17,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52849 0 0 0 0 0.566891 0 0 0 0 0.9125 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4",
    x1: 1148.5,
    y1: 1311.69,
    x2: 714.938,
    y2: 120.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 8492,
    fill: "white",
    transform: "translate(-560 -5447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimerBg);
export default __webpack_public_path__ + "static/media/ic_timer_bg.391c91853988f04faf965990d3fc1358.svg";
export { ForwardRef as ReactComponent };